import { map } from 'lodash';
import { Component, createElement } from 'react';
import ActionDropdown from '../../Common/ActionDropdown';
import HandleMenuItem from '../Handles/HandleMenuItem';

import CommandAction from './CommandAction';
import ConfirmationDialogAction from './ConfirmationDialogAction';
import FilterToggleAction from './FilterToggleAction';
import IdentityDocumentScannerAction from './IdentityDocumentScannerAction';
import LinkAction from './LinkAction';
import LoadingAction from './LoadingAction';
import ModalOpenerAction from './ModalOpenerAction';
import PrintAction from './PrintAction';
import SearchPageAction from './SearchPageAction';
import ToggleSwitchAction from './ToggleSwitchAction';

interface Props {
    action?: {
        text: string | React.ReactElement;
        items?: {}[] | $TSFixMe;
        icon: string;
    };
}

export default class DropdownAction extends Component<Props> {
    // @ts-expect-error $TSFixMeError: Parameter 'action' implicitly has an 'any' type.
    mapActionToActionProps = (action, index) => ({
        action,
        key: `${action.type}-${index}`,
        component: HandleMenuItem,
    });

    render() {
        // @ts-expect-error $TSFixMeError: Property 'items' does not exist on type '{ text: string | ReactElement<any, string | JSXElementConstructor<any>>; items?...
        const { items, icon, text, disabled } = this.props.action;

        const actions = map(items, (action, index) =>
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ CommandAction: Conn...
            createElement(ActionTemplates[action.type], this.mapActionToActionProps(action, index))
        );

        return (
            <ActionDropdown
                disabled={disabled}
                icon={icon}
                title={text}
                component={(this.props as $TSFixMe).component}
                expandIcon
            >
                {actions}
            </ActionDropdown>
        );
    }
}

const ActionTemplates = {
    CommandAction,
    ConfirmationDialogAction,
    DropdownAction,
    FilterToggleAction,
    IdentityDocumentScannerAction,
    LinkAction,
    LoadingAction,
    ModalOpenerAction,
    PrintAction,
    SearchPageAction,
    ToggleSwitchAction,
};
